namespace ProductOffering
{
    declare var apiUrl;
    declare var AttachmentUrl;

    export class ProductOfferContactModel {
        Name: string;
        Email: string;
    }

    export class ProductOfferModel {
        ContractCode: string;
        MeteringPointCode: string;
        NetworkCompanyCode: string;
        ProductName: string;
        ProductId: number;
        PriceListName: string;
        PriceListId: number;
        ConnectionSizeType: string;
        ConnectionSizeValue: string;
        Attachments: ProductOfferAttachment[];
        ProductComponents: ProductOfferProductComponentModel[];
        Id: number;
        Status: ProductOfferProductStatusEnum;
        StartDate: Moment;
    }

    export class ProductOfferAttachment {
        Name: string;
        AttachmentId: number;
    }
  
    export class ProductOfferProductComponentModel {
        Name: string;
        PriceNoVat: number;
        PriceWithVat: number;
        PriceUnit: string;
        ProductComponentType: ProductOfferProductComponentTypeEnum;
    }

    export enum ProductOfferProductComponentTypeEnum {
        BasicCharge,
        Energy1
    }
    
    export enum ProductOfferProductStatusEnum {
        Current,
        Offer,
        Pending,
        Accepted,
        Info
    }

    export class AcceptProductOfferModel {
        Id: number;
        Contact: ProductOfferContactModel;
        ProductName: string;
        StartTime: Date;
        MeteringPointCode: string;
    }

  


    export class ProductOfferingPage
    {
        service: ProductOfferingService = null;         
        consumptionPoints: any[];
        productInfoTemplate: any;
        productTemplate: any;
        productConditionsTemplate: any;
        productConfirmationTemplate: any;
        customerFirstName: string;
        customerLastName: string;
        customerEmail: string;
        customerCode: string;

        constructor(private container: JQuery)
        {
            if (this.service == null)
            {
                this.service = new ProductOfferingService();
            }

            var source = $("#productOfferingTemplate").html();
            this.productTemplate = Handlebars.compile(source);

            var source = $("#productInfoTemplate").html();
            this.productInfoTemplate = Handlebars.compile(source);

            source = $("#productOfferingConditionsTemplate").html();
            this.productConditionsTemplate = Handlebars.compile(source);      

            source = $("#productOfferingConfirmationTemplate").html();
            this.productConfirmationTemplate = Handlebars.compile(source);            

            Handlebars.registerHelper("currentStatus", currentProduct);
            Handlebars.registerHelper('isNotCurrent', isNotCurrent);
            Handlebars.registerHelper('isPending', isPending);
            Handlebars.registerHelper('isAccepted', isAccepted);
            Handlebars.registerHelper("getNumber", function (number) {
                return Globalize.format(number, "n2");
            });

            Handlebars.registerHelper("getDate", function (date: Moment) {
                if (date == null) return "";
                var local = moment.utc(date).local();
                var str = local.format("D.M.YYYY");
                return str;
            });

            Globalize.culture("fi-FI");
        }

       
        load(consumptionPoints: any[],customerCode:string,customerEmail: string, customerFistName: string, customerLastName: string)
        {            
            this.consumptionPoints = consumptionPoints;
            this.container.html("");

            this.customerEmail = customerEmail;
            this.customerFirstName = customerFistName;
            this.customerLastName = customerLastName;
            this.customerCode = customerCode;

            console.log(this.customerCode);
                              
            $.each(this.consumptionPoints, (ix, cp) => {

                var MPAddress = cp.Address.Street + ", " + cp.Address.Zip + " " + cp.Address.Place;

                this.container.append("<div class='row'><h3 style='display: inline;'>" + MPAddress + "</h3></div>")
                                      
                $.each(cp.MeteringPoints, (ix2, mp) => {

                    this.container.append("<div id='" + mp.MeteringPointCode + "'><span class='spinnerspan'><i class='fa fa-spinner fa-spin'></i> Ladataan käyttöpaikan tietoja ...</span></div><br/>")                                      

                    var custCode = customerCode;

                    //if (mp.Contracts > 0)
                    //    custCode = mp.Contracts[0].CustomerCode;

                    this.service.getOffers("", mp.NetworkCompanyCode, mp.MeteringPointCode,  "",
                        (d) => {

                            this.container.find("#" + mp.MeteringPointCode).find(".spinnerspan").remove();         

                            if (d && d.length > 0)
                            {
                                this.buildMeteringPointProductSelection(d, mp);
                            }
                        },
                        (e) => {

                            this.container.find("#" + mp.MeteringPointCode).find(".spinnerspan").remove();
                            this.container.find("#" + mp.MeteringPointCode).append("<div class='row'><div class='span9' style='padding-left: 30px;color:red;'>Virhe tietojen haussa</div></div>");
                            console.log(e);

                        });
                });

            });  
        }

        buildMeteringPointProductSelection(data: ProductOfferModel[], mp: any)
        {

            var offers = data;
            offers = offers.filter(t => t.Status != ProductOfferProductStatusEnum.Info);

            var html = this.productTemplate({ MeteringPointCode: mp.MeteringPointCode, AttachmentUrl: AttachmentUrl, Offers: offers });
            var el = $(html);
            this.container.find("#" + mp.MeteringPointCode).html("");
            this.container.find("#" + mp.MeteringPointCode).append(el);

            var info = data;
            info = info.filter(t => t.Status == ProductOfferProductStatusEnum.Info);

            if (info.length > 0)
            {
                var html2 = this.productInfoTemplate({ AttachmentUrl: AttachmentUrl, Offers: info });
                var el2 = $(html2);
                this.container.find("#" + mp.MeteringPointCode).append(el2);
            }

            var isPending = data.filter(t => t.Status == ProductOfferProductStatusEnum.Pending || t.Status == ProductOfferProductStatusEnum.Accepted);

            if (isPending.length > 0)
                return;

            el.find(".product:not(.current)").click(this.productClick);
            el.on("click", ".productCancelButton", this.productCancelClick);   
            el.on("click", ".productConfirmButton", this.productConfirmClick);
            el.on("click", ".productOrderButton", this.productOrderClick);
                    
            el.on("change", ".firstname", this.changeFirstName);
            el.on("change", ".lastname", this.changeLastName);
            el.on("change", ".email", this.changeEmail);
        }

        private changeFirstName = (e) => {

            this.customerFirstName = $(e.target).val();
        }

        private changeLastName = (e) => {

            this.customerLastName = $(e.target).val();
        }
        private changeEmail = (e) => {

            this.customerEmail = $(e.target).val();
        }


        private productClick = (e) => {
        
            var el = $(e.target);
            
            if (el.is("a"))
                return;

            if (!el.hasClass("product"))
                el = el.closest(".product");

            if (!el.hasClass("active")) {
                var id = el.attr("data-id");
                var parent = el.closest(".productDiv");
                parent.find(".product").removeClass("selected");
                parent.remove(".productconditions");
                               
                var startTime = el.attr("data-time");            
                parent.find(".productconditions").remove();


                var html = this.productConditionsTemplate({ ProductName: el.attr("data-product"), StartTime: startTime });
                parent.append($(html));

                parent.find(".productOrderButton").attr("data-id", id).attr("data-product", el.attr("data-product")).attr("data-time", el.attr("data-time"));                                         
                parent.find(".productCancelButton").attr("data-id", id);            
                el.addClass("selected");
            }
        }
           

        private productCancelClick = (e) => {

            var el = $(e.target);  
            var id = el.attr("data-id");
            var elem = $(".product[data-id='" + id + "']");
            var parent = $(elem).closest(".productDiv");
            parent.find(".product").removeClass("selected");

            parent.find(".productconditions").hide();
        }

        private productOrderClick = (e) =>
        {
            var el = $(e.target);
            el.attr("disabled","disabled");

            var parent = el.closest(".productconditions").find(".thumbnail");
            parent.find(".conditionButtons").hide();
            var html = this.productConfirmationTemplate({ FirstName: this.customerFirstName, LastName: this.customerLastName, Email: this.customerEmail });
            parent.append($(html));

            var id = el.attr("data-id");
            parent.find(".productConfirmButton").attr("data-id", id).attr("data-product", el.attr("data-product")).attr("data-time", el.attr("data-time"));        
            parent.find(".productCancelButton").attr("data-id", id);    

        }
       
        private  productConfirmClick = (e) =>
        {
            var el = $(e.target);
            var id = el.attr("data-id");

            var elem = $(".product[data-id='" + id + "']");
            var parent = $(elem).closest(".productDiv");

            parent.find(".mandatoryspan").hide();
            

            var model = new AcceptProductOfferModel();
            model.MeteringPointCode = id.split("#")[0];
            model.ProductName = el.attr("data-product");
            model.StartTime = moment(el.attr("data-time"), "DD.MM.YYYY").toDate();
            model.Id = parseInt(id.split("#")[1]);

            model.Contact = new ProductOfferContactModel();
            model.Contact.Name = this.customerFirstName + " " + this.customerLastName;
            model.Contact.Email = this.customerEmail;
                    

            if (model.Contact.Name.trim() == "" || model.Contact.Email == "" || !validateEmail(model.Contact.Email))
            {
                parent.find(".mandatoryspan").show();
                return;
            }

            if (model.Contact.Email.indexOf('hlv.fi') == -1 && model.Contact.Email.indexOf("inpulse.fi") == -1)
            {
                alert("Testivaiheessa vain @inpulse.fi sekä @hlv.fi sähköpostit hyväksytään.");
                return;
            }

            parent.find("input").attr("disabled", "");

            console.log(model);

            parent.find(".spinnerspan").show();
            parent.find(".confirmbuttons").hide();
               
            this.service.acceptOfferByProcessId(model,
                (d) => {
                                
                    parent.find(".product").removeClass("selected");
                    parent.find(".product").removeClass("");
                    parent.find(".spinnerspan").hide();
                    parent.find(".confirmtext").show();   
                    parent.find(".confirmbuttons").hide();
                    parent.find(".productOkButton").attr("data-id", id).show().click(this.productCancelClick);
               
                                                                   
                    $(elem).addClass("pending");
                    $(elem).find(".confirmationPending").html("Odottaa asiakaspalvelun tarkistusta.");
                    parent.find(".product").unbind("click");
                    parent.find(".productConfirmButton").attr("disabled","");
                    parent.find(".productCancelButton").html("Sulje");   
                },
                (e) => {

                    parent.find(".productOkButton").attr("data-id", id).show().click(this.productCancelClick);
                        //Do something with the error;

                });
                            
                

        }
        
        static hasProductOfferings()
        {

        }
     
    }

    export function currentProduct(status)
    {
        var va = <ProductOfferProductStatusEnum>status;

        if (va == ProductOfferProductStatusEnum.Current) {
            return "current active";
        }
        else if (va == ProductOfferProductStatusEnum.Pending) {
            return "pending";
        }
        else if (va == ProductOfferProductStatusEnum.Accepted) {
            return "pending";
        }
        else
        {
            return "";
        }      
    }

    export function isNotCurrent (val, options) {

        var va = <ProductOfferProductStatusEnum>val;
        var fnTrue = options.fn;
        var  fnFalse = options.inverse;

        return va == ProductOfferProductStatusEnum.Current ? fnFalse(this) : fnTrue(this);
    }

    export function isPending(val, options) {

        var va = <ProductOfferProductStatusEnum>val;
        var fnTrue = options.fn;
        var fnFalse = options.inverse;

        return va == ProductOfferProductStatusEnum.Pending ? fnTrue(this) : fnFalse(this);
    }

    export function isAccepted(val, options) {

        var va = <ProductOfferProductStatusEnum>val;
        var fnTrue = options.fn;
        var fnFalse = options.inverse;

        return va == ProductOfferProductStatusEnum.Accepted ? fnTrue(this) : fnFalse(this);
    }

    export class ProductOfferingService
    {
        getOffers(customerCode: string, sourceCompanyCode: string, meteringPointCode: string = null, networkCompanyCode: string = null,success:Function,error:Function)
        {
            Api.Get(apiUrl + "ProductOffering/GetOffers?customerCode=" + customerCode + "&sourceCompanyCode=" + sourceCompanyCode + "&meteringPointCode=" + meteringPointCode + "&networkCompanyCode=" + networkCompanyCode, success, error);
        }

        acceptOfferByProcessId(model: AcceptProductOfferModel, success: Function, error: Function)
        {
            Api.Post(apiUrl + "ProductOffering/AcceptOfferByProcessId", JSON.stringify(model), success, error);
        }

    }

    export function validateEmail(email) {

        $(".alert").not(".static").hide();
        var re = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        return re.test(email);
    }

}